'use client'
import React, { useState, useEffect } from 'react'
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import useDebounce from '@/library/utils/debounce';
import { useRouter } from 'next/navigation';
import SearchDefault from '@/library/blocks/searchs/SearchDefault';

export default function InstrumentListSearch(props) {
  const {
    onChange = () => { },
    placeholder,
  } = props

  return (
    <div>
      <SearchDefault placeholder={placeholder} onChange={onChange} />
    </div>
  )
}
